module.exports = __webpack_public_path__ + "img/leveraging-distortions--explanation--idealization--and-universality-in-science-cover.87ac2f61.jpg";